if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        container: "[data-variant-picker]",
        productInfo: ".m-product-info--wrapper",
        error: ".m-product-form-message",
        variantIdInput: '[name="id"]',
        pickerFields: ["[data-picker-field]"],
        optionNodes: [".m-product-option--node"],
        productSku: "[data-variant-sku]",
        productAvailability: "[data-availability]",
        shareUrlInput: "[data-share-url]",
        stockCountdown: ".prod__stock-countdown",
        productWrapper: ".m-main-product__wrapper",
      };

      this.container = this.closest(this.selectors.container);
      this.productWrapper = this.closest(this.selectors.productWrapper);
      this.productInfo = this.closest(this.selectors.productInfo);
      this.domNodes = queryDomNodes(this.selectors, this.productInfo);
    }

    connectedCallback() {
      this.setupData();
    }

    async setupData() {
      const themeProducts = window._themeProducts || {};
      let productData = themeProducts[this.container.dataset.productId];
      this.productId = this.container.dataset.productId;
      this.sectionId = this.container.dataset.section;
      this.productUrl = this.container.dataset.productUrl;
      this.productHandle = this.container.dataset.productHandle;
      this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`);
      this.variantData = this.getVariantData();
      this.productData = Object.assign(await this.getProductJson(), productData);
      this.showFeaturedMedia = this.dataset.showFeaturedMedia === "true";

      this.enableVariantGroupImages = this.container.dataset.enableVariantGroupImages === "true";
      if (this.enableVariantGroupImages) {
        this.variantGroupImages = this.getVariantGroupImageData();
      }

      const selectedVariantId = this.productInfo.querySelector(this.selectors.variantIdInput).value;
      this.currentVariant = this.productData.variants.find((variant) => variant.id === Number(selectedVariantId));
      this.productData.current_variant_id = this.currentVariant && this.currentVariant.id;
      this.productData.initialVariant = this.currentVariant;

      if (this.currentVariant) {
        this.getDataImageVariant(this.currentVariant.id);
        this.hideSoldOutAndUnavailableOptions();
        this.updateButton(!this.currentVariant.available, "", false);
      }

      // Check media gallery inital
      this.getMediaGallery();
      document.addEventListener("matchMobile", () => {
        this.getMediaGallery();
      });
      document.addEventListener("unmatchMobile", () => {
        this.getMediaGallery();
      });
      this.initOptionSwatches();
      this.addEventListener("change", this.onVariantChange);
    }

    getMediaGallery() {
      this.mediaGallery = this.section.querySelectorAll("media-gallery");
      this.check = setInterval(() => {
        if (this.mediaGallery) {
          this.mediaGallery.forEach((media) => {
            if (window.getComputedStyle(media).display !== "none" && media.mediaMode) {
              clearInterval(this.check);
              this.layout = media.layout;
              this.media = media;
              if (media.mediaMode === "slider") {
                this.slides = media.slider.slides;
                if (media.navSlider) {
                  this.slidesNav = media.navSlider.slides;
                }
              } else {
                this.mediaItems = media.querySelectorAll(".m-product-media--item");
              }
              if (!this.showFeaturedMedia || (this.enableVariantGroupImages && this.variantGroupImages.enable)) {
                this.updateMedia();
              }
            }
          });
        }
      }, 100);
    }

    onVariantChange() {
      this.getSelectedOptions();
      this.getSelectedVariant();
      this.updateButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.updateButton(true, "", true);
        this.setUnavailable();
      } else {
        this.getDataImageVariant(this.currentVariant.id);
        this.updateMedia();
        this.updateBrowserHistory();
        this.updateVariantInput();
        this.updateProductMeta();
        this.updatePrice();
        this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
        this.hideSoldOutAndUnavailableOptions();
      }
      window.MinimogEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this);

      document.dispatchEvent(new Event("BSS:changeVariantQV"));
    }

    getDataImageVariant(variantId) {
      if (this.variantGroupImages && this.variantGroupImages.enable) {
        this.currentVariantMedia =
          this.variantGroupImages.mapping.find((variant) => Number(variant.id) === variantId) &&
          this.variantGroupImages.mapping.find((variant) => Number(variant.id) === variantId).media;
      }
    }

    getProductJson() {
      return fetch(this.productUrl + ".js")
        .then((response) => {
          if (!response.ok) {
            const productData = JSON.parse(
              this.productWrapper.querySelector("#productData[type='application/json']").textContent
            );
            return productData;
          } else {
            return response.json();
          }
        })
        .catch((err) => console.log(err));
    }

    getSelectedVariant() {
      let variant = getVariantFromOptionArray(this.productData, this.options);
      let options = [...this.options];
      if (!variant) {
        options.pop();
        variant = getVariantFromOptionArray(this.productData, options);
        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(this.productData, options);
        }
        this.options = [...variant.options];
        this.updateSelectedOptions();
      }
      this.currentVariant = variant;
    }

    getSelectedOptions() {
      const pickerFields = Array.from(this.querySelectorAll("[data-picker-field]"));
      this.options = pickerFields.map((field) => {
        const type = field.dataset.pickerField;
        if (type === "radio") return Array.from(field.querySelectorAll("input")).find((radio) => radio.checked).value;
        return field.querySelector("select").value;
      });
    }

    updateSelectedOptions() {
      this.domNodes.pickerFields.forEach((field, index) => {
        const selectedValue = field.dataset.selectedValue;
        if (selectedValue !== this.options[index]) {
          const selectedOption = field.querySelector(`input[value="${this.options[index].replace(/["\\]/g, "\\$&")}"]`);
          if (selectedOption) {
            selectedOption.checked = true;
            field.updateSelectedValue();
          }
        }
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      let mainItems = [],
        navItems = [];
      let index = 0,
        index0 = 0,
        indexNav = 0,
        indexNav0 = 0;
      if (this.variantGroupImages && this.variantGroupImages.enable) {
        if (this.media.mediaMode === "slider" && this.slides) {
          // Re-render main media
          this.slides.forEach((slide) => {
            const dataIdMedia = slide.querySelector("[data-media-id]").dataset.mediaId;
            if (this.currentVariantMedia && this.currentVariantMedia.length > 0) {
              if (this.currentVariantMedia.includes(dataIdMedia)) {
                slide.dataset.swiperSlideIndex = index++;
                slide.dataset.index = index0++;
                if (slide.dataset.swiperSlideIndex === "0") slide.classList.add("swiper-slide-active");
                mainItems.push(slide);
              }
              if (!slide.classList.contains("media-type-image")) {
                slide.dataset.swiperSlideIndex = index++;
                slide.dataset.index = index0++;
                mainItems.push(slide);
              }
            } else {
              slide.dataset.swiperSlideIndex = index++;
              slide.dataset.index = index0++;
              mainItems.push(slide);
            }
          });
          this.media.slider.removeAllSlides();
          this.media.slider.appendSlide(mainItems);
          this.media.slider.slideToLoop(0);
          this.media.handleSlideChange();

          // Re-render nav media
          this.slidesNav &&
            this.slidesNav.forEach((slide) => {
              const dataIdMedia = slide.querySelector("[data-media-id]").dataset.mediaId;
              if (this.currentVariantMedia.length > 0) {
                if (this.currentVariantMedia.includes(dataIdMedia)) {
                  slide.dataset.swiperSlideIndex = indexNav++;
                  slide.dataset.index = indexNav0++;
                  if (slide.dataset.swiperSlideIndex === "0") slide.classList.add("swiper-slide-thumb-active");
                  navItems.push(slide);
                }
                if (!slide.classList.contains("media-type-image")) {
                  slide.dataset.swiperSlideIndex = indexNav++;
                  slide.dataset.index = indexNav0++;
                  navItems.push(slide);
                }
              } else {
                slide.dataset.swiperSlideIndex = indexNav++;
                slide.dataset.index = indexNav0++;
                slide.classList.remove("swiper-slide-thumb-active");
                if (slide.dataset.swiperSlideIndex === "0") slide.classList.add("swiper-slide-thumb-active");
                navItems.push(slide);
              }
            });
          this.media.navSlider && this.media.navSlider.removeAllSlides();
          this.media.navSlider && this.media.navSlider.appendSlide(navItems);
          this.media.navSlider && this.media.navSlider.slideToLoop(0);

          // Remove loading
          this.media && this.media.removeAttribute("data-media-loading");
          this.media ? (this.media.firstElementChild.style.opacity = 1) : null;
        } else {
          let index = 0;
          const mediaWraper = this.media.querySelector(".m-product-media--list");
          this.mediaItems.forEach((item) => {
            const dataIdMedia = item.querySelector("[data-media-id]").dataset.mediaId;
            if (this.currentVariantMedia.length > 0) {
              if (this.currentVariantMedia.includes(dataIdMedia)) {
                item.dataset.index = index++;
                mainItems.push(item);
              }
              if (!item.classList.contains("media-type-image")) {
                item.dataset.index = index++;
                mainItems.push(item);
              }
            } else {
              item.dataset.index = index++;
              mainItems.push(item);
            }
            mediaWraper.innerHTML = "";
            mainItems.forEach((item) => {
              mediaWraper.append(item);
            });
          });

          // Remove loading
          this.media && this.media.removeAttribute("data-media-loading");
          this.media ? (this.media.firstElementChild.style.opacity = 1) : null;
        }
      } else {
        const mediaSize = parseInt(this.media && this.media.dataset.mediaSize);
        if (mediaSize > 0) this.media.setActiveMedia(this.currentVariant, this.media);
      }

      const customData = [];

      if (mainItems.length > 0) {
        mainItems.forEach((media, index) => {
          if (media.dataset.mediaType === "image") {
            const mediaDataItem = media.querySelector(".m-product-media");
            const mediaData = mediaDataItem.dataset;
            customData.push({
              src: mediaData.mediaSrc,
              width: parseInt(mediaData.mediaWidth),
              height: parseInt(mediaData.mediaHeight),
              alt: mediaData.mediaAlt,
              id: media.dataset.index,
            });
          } else {
            customData.push({
              html: `<div class="pswp__${media.dataset.mediaType}">${media.innerHTML}</div>`,
              type: media.dataset.mediaType,
              id: media.dataset.index,
            });
          }
        });
      }

      // Init Photoswipe
      this.media && this.media.lightbox && this.media.lightbox.destroy();
      this.media && this.media.handlePhotoswipe(customData);
      this.media && this.media.initPhotoswipe();
    }

    updateBrowserHistory() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState({}, "", `${this.productUrl}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const variantIdInput = productForm.querySelector(this.selectors.variantIdInput);
        variantIdInput.value = this.currentVariant.id;
        variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.section.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    updatePrice() {
      const classes = {
        onSale: "m-price--on-sale",
        soldOut: "m-price--sold-out",
      };
      const selectors = {
        priceWrapper: ".m-price",
        salePrice: ".m-price-item--sale",
        compareAtPrice: [".m-price-item--regular"],
        unitPrice: ".m-price__unit",
        unitPriceWrapper: ".m-price__unit-wrapper",
        saleBadge: ".m-price__badge-sale",
        saleAmount: "[data-saved-price]",
      };
      const mainProductPrices = this.productInfo.querySelector(".main-product__block-price");
      if (!mainProductPrices) return;
      const money_format = window.MinimogSettings.money_format;
      const { priceWrapper, salePrice, unitPrice, compareAtPrice, saleBadge, saleAmount, unitPriceWrapper } =
        queryDomNodes(selectors, mainProductPrices);

      const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
      const saleBadgeType = priceWrapper.dataset.saleBadgeType;

      const onSale = compare_at_price && compare_at_price > price;
      const soldOut = !this.currentVariant.available;

      if (onSale) {
        priceWrapper.classList.add(classes.onSale);
      } else {
        priceWrapper.classList.remove(classes.onSale);
      }

      if (soldOut) {
        priceWrapper.classList.add(classes.soldOut);
      } else {
        priceWrapper.classList.remove(classes.soldOut);
      }

      if (priceWrapper) priceWrapper.classList.remove("visibility-hidden");
      if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

      if (compareAtPrice.length && compare_at_price > price) {
        compareAtPrice.forEach((item) => (item.innerHTML = formatMoney(compare_at_price, money_format)));
      } else {
        compareAtPrice.forEach((item) => (item.innerHTML = formatMoney(price, money_format)));
      }

      if (saleBadge && compare_at_price > price && saleBadgeType !== "text") {
        let value;
        if (saleBadgeType === "fixed_amount") {
          value = formatMoney(compare_at_price - price, money_format);
        } else {
          const saving = ((compare_at_price - price) * 100) / compare_at_price;
          value = Math.round(saving) + "%";
        }
        saleAmount.innerHTML = value;
      }

      if (unit_price_measurement && unitPrice) {
        unitPriceWrapper.classList.remove("m:hidden");
        const unitPriceContent = `<span>${formatMoney(
          this.currentVariant.unit_price,
          money_format
        )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
        unitPrice.innerHTML = unitPriceContent;
      } else {
        unitPriceWrapper.classList.add("m:hidden");
      }
    }

    _getBaseUnit = () => {
      return this.currentVariant.unit_price_measurement.reference_value === 1
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value +
            this.currentVariant.unit_price_measurement.reference_unit;
    };

    updateButton(disable = true, text, modifyClass = true) {
      const productForms = document.querySelectorAll(`.product-form-${this.sectionId}`);
      if (!productForms) return;
      productForms.forEach((productForm) => {
        const addButton = productForm.querySelector('[name="add"]');
        const dynamicCheckout = productForm.querySelector(".m-product-dynamic-checkout");
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          addButton.classList.add("disabled");
          dynamicCheckout && dynamicCheckout.classList.add("disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          dynamicCheckout && dynamicCheckout.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCart;
        }
      });
    }

    updateProductMeta() {
      const { available, sku } = this.currentVariant;
      const { inStock, outOfStock } = window.MinimogStrings;
      const productAvailability = this.section.querySelector(this.selectors.productAvailability);
      const productSku = this.section.querySelector(this.selectors.productSku);

      if (productSku) {
        if (sku) {
          productSku.textContent = sku;
        } else {
          productSku.textContent = "N/A";
        }
      }

      if (productAvailability) {
        const method = !available ? "add" : "remove";
        productAvailability.textContent = available ? inStock : outOfStock;
        productAvailability.classList[method]("m-product-availability--outofstock");
      }
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.sectionId}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span.m-add-to-cart--text');
      const priceWrapper = this.section.querySelector(".m-price");
      if (!addButton) return;
      addButtonText.textContent = window.MinimogStrings.unavailable;
      if (priceWrapper) priceWrapper.classList.add("visibility-hidden");
    }

    hideSoldOutAndUnavailableOptions = () => {
      const classes = {
        soldOut: "m-product-option--node__soldout",
        unavailable: "m-product-option--node__unavailable",
      };
      const variant = this.currentVariant;
      const { optionNodes } = this.domNodes;
      const {
        productData,
        productData: {
          variants,
          options: { length: maxOptions },
        },
      } = this;

      optionNodes.forEach((optNode) => {
        const { optionPosition, value } = optNode.dataset;
        const optPos = Number(optionPosition);
        const isSelectOption = optNode.tagName === "OPTION";

        let matchVariants = [];
        if (optPos === maxOptions) {
          const optionsArray = Array.from(variant.options);
          optionsArray[maxOptions - 1] = value;
          matchVariants.push(getVariantFromOptionArray(productData, optionsArray));
        } else {
          matchVariants = variants.filter(
            (v) => v.options[optPos - 1] === value && v.options[optPos - 2] === variant[`option${optPos - 1}`]
          );
        }

        matchVariants = matchVariants.filter(Boolean);
        if (matchVariants.length) {
          optNode.classList.remove(classes.unavailable);
          isSelectOption && optNode.removeAttribute("disabled");
          const isSoldOut = matchVariants.every((v) => v.available === false);
          const method = isSoldOut ? "add" : "remove";
          optNode.classList[method](classes.soldOut);
        } else {
          optNode.classList.add(classes.unavailable);
          isSelectOption && optNode.setAttribute("disabled", "true");
        }
      });
    };

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.container.querySelector('#productVariants[type="application/json"]').textContent);
      return this.variantData;
    }

    getVariantGroupImageData() {
      this.variantGroupImages =
        this.variantGroupImages ||
        JSON.parse(this.container.querySelector('#variantGroup[type="application/json"]').textContent);
      return this.variantGroupImages;
    }

    initOptionSwatches() {
      const { _colorSwatches = [], _imageSwatches = [] } = window.MinimogSettings;
      this.domNodes.optionNodes &&
        this.domNodes.optionNodes.forEach((optNode) => {
          const { optionType, optionPosition, value: optionValue } = optNode.dataset;
          const optionValueLowerCase = optionValue.toLowerCase();
          const variantToShowSwatchImage = this.variantData.find((v) => v[`option${optionPosition}`] === optionValue);

          const variantImage =
            variantToShowSwatchImage &&
            variantToShowSwatchImage.featured_image &&
            variantToShowSwatchImage.featured_image.src
              ? getSizedImageUrl(variantToShowSwatchImage.featured_image.src, "100x")
              : variantToShowSwatchImage.featured_image
              ? variantToShowSwatchImage.featured_image.src
              : null;
              
          const customImage = _imageSwatches.find((i) => i.key === optionValueLowerCase)
            ? _imageSwatches.find((i) => i.key === optionValueLowerCase).value
            : "";
          const customColor = _colorSwatches.find((c) => c.key === optionValueLowerCase)
            ? _colorSwatches.find((c) => c.key === optionValueLowerCase).value
            : "";
          if (variantImage || customImage) {
            optNode.querySelector("label") ? optNode.querySelector("label").classList.add("has-bg-img") : null;
          }
          switch (optionType) {
            case "default":
              optNode.querySelector("label").style.backgroundImage = `url(${customImage || variantImage || ""})`;
              optNode.querySelector("label").classList.remove("option-loading");
              break;
            case "image":
              optNode.querySelector("label").style.backgroundImage = `url(${variantImage || customImage || ""})`;
              optNode.querySelector("label").classList.remove("option-loading");
              break;
            case "color":
              optNode.querySelector("label").style.backgroundColor = customColor ? customColor : optionValueLowerCase;
              if (customImage) optNode.querySelector("label").style.backgroundImage = `url(${customImage})`;
              optNode.querySelector("label").classList.remove("option-loading");
              break;
            default:
              break;
          }
        });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
if (!customElements.get("variant-button")) {
  class VariantButton extends HTMLElement {
    constructor() {
      super();
      this.selectedSpan = this.querySelector(".option-label--selected");
      this.addEventListener("change", this.updateSelectedValue);
    }

    updateSelectedValue() {
      this.value = Array.from(this.querySelectorAll("input")).find((radio) => radio.checked).value;
      this.setAttribute("data-selected-value", this.value);
      if (this.selectedSpan) this.selectedSpan.textContent = this.value;
    }
  }

  customElements.define("variant-button", VariantButton);

  if (!customElements.get("variant-select")) {
    class VariantSelect extends VariantButton {
      constructor() {
        super();
      }

      updateSelectedValue() {
        this.value = this.querySelector("select").value;
        this.setAttribute("data-selected-value", this.value);
        if (this.selectedSpan) this.selectedSpan.textContent = this.value;
      }
    }

    customElements.define("variant-select", VariantSelect);
  }
  if (!customElements.get("variant-image")) {
    class VariantImage extends VariantButton {
      constructor() {
        super();
      }
    }

    customElements.define("variant-image", VariantImage);
  }
  if (!customElements.get("variant-color")) {
    class VariantColor extends VariantButton {
      constructor() {
        super();
      }
    }
    customElements.define("variant-color", VariantColor);
  }
}
